import React, { useEffect  }  from "react";
import { connect } from "react-redux";
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Input, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { requiredField } from '../../utils/crudSagaHelper';
import { doConfirmRegistration, doCancelRegistration } from "../../redux/auth/authState";
import PanelBanner from "components/banners/PanelBanner";
import { DATE_FORMAT } from '../../variables/constants';
import CrudButtons from "components/button/crudbuttons";
import RegionProvinceBarangay from "components/fields/RegionProvinceBarangay";
import CardItem from "components/card/CardItem";
import { ReactComponent as Logo } from 'assets/svg/intsamis_logo.svg';

const ManualRegister = ({confirmRegistration, cancelRegistration}) => {
  
  const [form] = useForm();
  const recordData = {};

  const handleCancelRegistration = () =>{
    cancelRegistration();
  }

  useEffect(() => {
    const initialValues = {};
      form.setFieldsValue(initialValues);
    }, [form]);

  const onSubmit = (formData) => {	
		try {  
			formData.redirect = false;
			confirmRegistration(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

  return (
    <div className="m-4 flex flex-col h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
      <PanelBanner/>

      <CardItem extra={"w-full p-4 max-w-[800px]"}
        icon={<Logo/>}
        htmlTitle={<h4 className="ml-4 card-title text-3xl dark:text-theme-200">Manual Registration</h4>}
      >
        <Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
          layout="vertical"
          onFinish={onSubmit}
        >
          <div className="form-column-4">   
            <FormItem 
              name="last_name"
              label="SurName"
              rules={[requiredField()]}
            >
              <Input id="last_name"
                maxLength={50}		            		
              />            
            </FormItem>        
            <FormItem 
              name="first_name"
              label="First Name"
              rules={[requiredField()]}
            >
              <Input id="first_name"
                maxLength={50}		            		
              />
            </FormItem>
            <FormItem 
              name="middle_name"
              label="Middle Name"
              rules={[requiredField()]}
            >
              <Input id="middle_name"
                maxLength={50}		            		
              />
            </FormItem>
            <FormItem 
              name="suffix"
              label="Extension Name"					
            >
              <Input id="suffix"
                maxLength={20}		            		
              />
            </FormItem>									            	            		            	 
            <FormItem 
              name="gender"
              label="Gender"
              rules={[requiredField()]}
            >
              <Select id="gender"
                allowClear={true}		           
              />
            </FormItem>
            <FormItem 
              name="date_of_birth"
              label="Date of Birth"
              rules={[requiredField()]}
            >
              <DatePicker id="date_of_birth"
                format={DATE_FORMAT}
              />
            </FormItem>
            <FormItem 
              extra="col-span-2"
              name="place_of_birth"
              label="Place of Birth"
              rules={[requiredField()]}
            >
              <Input id="place_of_birth"
                maxLength={100}		            		
              />
            </FormItem>
          </div>

          <label className="form-section-label">ADDRESS</label>
          <div className="form-column-4">				
            <FormItem extra="col-span-4"
              name="address_address_line1"
              label="House/Lot/Bldg. No./Purok"
              rules={[requiredField()]}
            >
              <Input id="address_address_line1"
                maxLength={100}		            		
              />
            </FormItem>
            <FormItem extra="col-span-4"
              name="address_address_line2"
              label="Street/Sitio/Subdv."
            >
              <Input id="address_address_line2"
                maxLength={100}		            		
              />
            </FormItem>
            <div className="col-span-4">
              <RegionProvinceBarangay recordData={recordData} 
                mode="edit" 
                form={form} 
                rules={[requiredField()]}/>
            </div>
          </div>	

          <CrudButtons baseRoute="/panel/my-farmer-information" 
            mode="edit" 
            recordId={0}
            backUrl="/panel/services"
            cancelUrl="/panel/services"
            cancelLabel="Back"/>
        </Form>	 	
      </CardItem>

    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
  scannedQR: state.auth.scannedQR,
  qrUser: state.auth.qrUser,
});

const mapDispatchToProps = (dispatch) => ({
  confirmRegistration: (qrdata) => dispatch(doConfirmRegistration(qrdata)),
  cancelRegistration: () => dispatch(doCancelRegistration()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManualRegister);